import { useIntl } from "react-intl";
import { type Asserts, bool, object } from "yup";

export const formValidationSchema = object({
  marketing: bool().required(),
  whatsappConsent: bool().required(),
  privacyPolicy: bool().required().equals([true]),
  softwareTermsOfUse: bool().required().equals([true]),
});

export type FormValues = Asserts<typeof formValidationSchema>;

// Keeping for backwards compatibility
export const formValidationSchemaWithWhatsapp = formValidationSchema;

export const SoftwareTermsOfUseLink = () => {
  const { formatMessage } = useIntl();

  return (
    <a
      href="https://privacy.elephant.healthcare/software-terms-of-use"
      target="_blank"
      rel="noopener noreferrer"
    >
      {formatMessage({
        id: "auth.consent.softwareTermsOfUserLinkText",
        defaultMessage: "Software Terms of Use",
      })}
    </a>
  );
};

export const PrivacyPolicyLink = () => {
  const { formatMessage } = useIntl();

  return (
    <a
      href="https://privacy.elephant.healthcare/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
    >
      {formatMessage({
        id: "auth.consent.privacyPolicyLinkText",
        defaultMessage: "Privacy Policy",
      })}
    </a>
  );
};
